import { FC } from "react";
import { useRouter } from "next/router";
import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";

import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";

import { usePacks } from "../Packs/usePacks";
import {
  eventsState,
  selectEventsSelected,
} from "@/global/store/data/purchaseSeats/events";
import { useBuckets } from "../Buckets/useBuckets";
import { createState } from "@/global/store/zustand_store";
import { useAppDispatch, useAppStore } from "@/global/store";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { useTranslation } from "react-i18next";

export const useTransactionErrorGenericModal = createState({
  isOpen: false,
  errorMessage: "",
});

export const TransactionErrorGenericModal: FC = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const transactionErrorGenericModal = useTransactionErrorGenericModal();
  const { isPacksEnabled } = usePacks();
  const { sm } = useCssMediaQuery("down");
  const { isBucketsEnabled } = useBuckets();
  const selectedEvents = useAppStore(selectEventsSelected);
  const teamConfig = useTeamConfig();
  const { t } = useTranslation();

  async function onClose() {
    const { teamSchema } = teamConfig;

    if (isBucketsEnabled || isPacksEnabled)
      dispatch(
        eventsState.actions.removeEventMulti(
          selectedEvents.map((event) => event.eventCode)
        )
      );

    transactionErrorGenericModal.set({ isOpen: false, errorMessage: "" });
    await router.push({
      pathname: teamConfig.defaultRoute,
      query: { teamSchema },
    });
  }

  return (
    <NotificationModal
      hideTitleIcon
      hidePrimaryButton
      onClose={onClose}
      title={
        t("giftCard.checkout.errorModal.invalidTransationTitle") ||
        "Invalid Transaction"
      }
      hideSecondaryButton
      isOpen={transactionErrorGenericModal.isOpen}
      paperProps={{ style: { marginLeft: 2, marginRight: 2 } }}
      renderBody={() => (
        <Box>
          <Box p={sm ? 2 : 3}>
            <Box>
              <Typography variant="body1">
                {transactionErrorGenericModal.errorMessage}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      renderFooter={() => {
        return (
          <Stack
            py={2}
            px={2}
            gap={2}
            width={"100%"}
            justifyContent={"flex-end"}
            direction={"row"}
          >
            <LoadingButton
              size={"large"}
              onClick={onClose}
              variant={"contained"}
              sx={{
                fontWeight: 600,
                width: sm ? "fit-content" : "180px",
              }}
            >
              {t("giftCard.checkout.errorModal.closeButtonText") || "Close"}
            </LoadingButton>
          </Stack>
        );
      }}
    />
  );
};
